import { useLocation } from 'react-router-dom'

import { getOauthClient, getToken } from 'utils'

const PrivateRoute = ({ children }) => {
  const somosIdEnabled = JSON.parse(process.env.REACT_APP_SOMOS_ID_ENABLED)
  const location = useLocation()

  if (!somosIdEnabled) {
    return children
  }

  if (getToken()) {
    return children
  }

  const OAuth = getOauthClient(location.pathname)
  window.location.href = OAuth.token.getUri()
  return null
}

export default PrivateRoute
